import { lazy } from 'react'

import { PLAYER_URL } from '../constants'

const PlayerFormScreen = lazy(
  // @todo find a way to test this
  /* istanbul ignore next */
  () => import(/* webpackChunkName: 'players' */ '../screens/PlayerFormScreen'),
)

export default [
  {
    component: PlayerFormScreen,
    path: PLAYER_URL,
  },
]
